import { render, staticRenderFns } from "./CardPlace2.vue?vue&type=template&id=06205512&scoped=true"
import script from "./CardPlace2.vue?vue&type=script&lang=js"
export * from "./CardPlace2.vue?vue&type=script&lang=js"
import style0 from "./CardPlace2.vue?vue&type=style&index=0&id=06205512&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06205512",
  null
  
)

export default component.exports